<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <v-select
        :clearable="false"
        v-if="!isLoading && showChangeEstablecimiento"
        :value="establecimiento"
        :options="establecimientoOpts"
        :reduce="option => option.value"
        label="text"
        style="width: 200px;"
        class="mr-2"
        @input="confirmChange"
      /> -->

      <h4 class="mx-3 mb-0 font-weight-bolder" :class="environmentBadgeClass">
        Ambiente:
        <span>{{ environmentLabel }}</span>
      </h4>

      <h5 class="mx-3 mb-0">
        Establecimiento:
        <span class="text-success">{{ establecimientoName }}</span>
      </h5>

      <div class="mx-2">
        <div class="d-md-flex d-none">
          <p class="font-weight-bolder mb-0">
            <b-button
              @click="openModalAuditadas()"
              pill
              variant="outline-secondary"
              v-b-tooltip.hover
              title="Revisar comentarios auditoria"
            >
              <i class="fa-solid fa-bell mr-1"></i>
              <b-badge variant="warning"
                >{{ cantidadComentarios }}
                <span class="sr-only">Notificaciones</span></b-badge
              >
            </b-button>
          </p>
        </div>
      </div>

      <div class="mx-2" v-if="isJefeMedico">
        <div class="d-md-flex d-none">
          <p class="font-weight-bolder mb-0">
            <b-button
              @click="openModalAuditadasByUser()"
              pill
              variant="outline-secondary"
              v-b-tooltip.hover
              title="Revisar mis atenciones auditadas"
            >
              <i class="fa-solid fa-bell mr-1"></i>
              <b-badge variant="info"
                >{{ cantidadComentariosByAuditor }}
                <span class="sr-only">Notificaciones</span></b-badge
              >
            </b-button>
          </p>
        </div>
      </div>

      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ usuario.username }}
            </p>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="detalleusuario.avatarruta"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{ name: 'mi-perfil' }"
        >
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>Mi Perfil</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>Salir</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-modal
      id="modal-auditadas"
      size="lg"
      hide-footer
      title="Atenciones por revisar"
    >
      <div>
        <div v-if="cantidadComentarios > 0">
          <div v-for="(aud, i) in auditados" :key="i">
            <b-row class="mx-1">
              <b-col> Fecha: {{ aud.cita.fechaCita }}</b-col>
              <b-col class="col-7">
                Paciente:
                {{ aud.cita.paciente.persona.identificacion }}
                {{ aud.cita.paciente.persona.primerApellido }}
                {{ aud.cita.paciente.persona.primerNombre }}
              </b-col>
              <b-col>
                Auditor:
                <label v-if="aud.auditorUser">{{
                  aud.auditorUser.username
                }}</label>
              </b-col>
              <b-col>
                <b-button
                  pill
                  @click="irAtencion(aud.token)"
                  variant="success"
                  size="sm"
                  >Ir</b-button
                >
              </b-col>
            </b-row>
            <hr />
          </div>
        </div>

        <div v-else>
          <div class="m-3 text-center">
            <b-alert variant="success" show
              >No existen atenciones por revisar.</b-alert
            >
            <i class="fa-solid fa-mug-hot fa-6x"></i>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-auditadas-user"
      size="lg"
      hide-footer
      title="Atenciones auditadas por este usuario"
    >
      <div v-if="isJefeMedico">
        <!-- ⭐ BUSCADOR COMPLETO ⭐ -->
        <b-input-group class="mb-3" >
          <!-- TEXTO -->
          <b-form-input
            v-model="searchInput"
            placeholder="Buscar por cédula, nombre o apellido..."
            class="mr-2"
          ></b-form-input>

          <b-form-select
            v-model="estadoFilter"
            :options="[
              { value: '', text: 'Todos' },
              { value: '1', text: 'Por revisar' },
              { value: '2', text: 'Revisado' },
              { value: '3', text: 'Concluido' },
            ]"
            class="mr-2"
          ></b-form-select>

          <!-- FECHA -->
          <b-form-datepicker
            v-model="dateInput"
            placeholder="Fecha de cita"
            class="mr-2"
          ></b-form-datepicker>

          <b-input-group-append>
            <b-button variant="primary" @click="doSearch"> Buscar </b-button>

            <b-button variant="outline-secondary" @click="clearSearch">
              Limpiar
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <div v-if="pagedFilteredItems.length > 0">
          <!-- TABLA -->
          <b-table
            :items="pagedFilteredItems"
            :fields="fields"
            striped
            hover
            small
            responsive
          >
            <!-- FECHA -->
            <template #cell(fecha)="data">
              {{ data.item.cita.fechaCita }}
            </template>

            <!-- PACIENTE -->
            <template #cell(paciente)="data">
              {{ data.item.cita.paciente.persona.identificacion }}
              {{ data.item.cita.paciente.persona.primerApellido }}
              {{ data.item.cita.paciente.persona.primerNombre }}
            </template>

            <!-- AUDITOR -->
            <template #cell(auditor)="data">
              <span v-if="data.item.auditorUser">
                {{ data.item.auditorUser.username }}
              </span>
            </template>

            <!-- ESTADO -->
            <template #cell(estadoauditoria)="data">
              <b-alert
                class="mt-1"
                v-if="data.item.estadoauditoria === '1'"
                variant="danger"
                show
              >
                Por revisar
              </b-alert>
              <b-alert
                class="mt-1"
                v-if="data.item.estadoauditoria === '2'"
                variant="info"
                show
              >
                Revisado
              </b-alert>
              <b-alert
                class="mt-1"
                v-if="data.item.estadoauditoria === '3'"
                variant="success"
                show
              >
                Concluido
              </b-alert>
            </template>

            <!-- ACCIONES -->
            <template #cell(acciones)="data">
              <b-button
                pill
                variant="success"
                size="sm"
                @click="irAtencion(data.item.token)"
              >
                Ir
              </b-button>
            </template>
          </b-table>

          <!-- PAGINACIÓN -->
          <b-pagination
            v-model="currentPage"
            :total-rows="filteredItems.length"
            :per-page="perPage"
            align="center"
            size="sm"
            class="mt-2"
          ></b-pagination>
        </div>

        <div v-else>
          <div class="m-3 text-center">
            <b-alert variant="success" show
              >No existen atenciones auditadas por este usuario.</b-alert
            >
            <i class="fa-solid fa-mug-hot fa-6x"></i>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";

import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import vSelect from "vue-select";
import { comprobarRoles, getEstablecimientoLS } from "../../shared/helpers";
import { establecimientosService } from "../../views/administracion/services/establecimientosService";
import { ROLES } from "../../shared/constants";
import { ESTABLECIMIENTOS } from "../../shared/constants/establecimientos";
import { atencionAuditoriaService } from "../../views/atencionMedica/services";
import { isJefeMedico } from "../../views/derivaciones/helpers";
import { API_ENV_STORAGE_KEY } from "../../shared/helpers/apiEnvironment";

export default {
  components: {
    vSelect,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    DarkToggler,
    atencionAuditoriaService,
  },

  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      fields: [
        { key: "fecha", label: "Fecha" },
        { key: "paciente", label: "Paciente" },
        { key: "estadoauditoria", label: "Estado" },
        { key: "auditor", label: "Auditor" },
        { key: "acciones", label: "Acciones" },
      ],
      estadoFilter: null,
      perPage: 5,
      currentPage: 1,
      searchInput: "", // texto que escribe el usuario
      search: "", // texto aplicado al filtro
      dateInput: null, // fecha seleccionada en datepicker
      dateFilter: null, // fecha aplicada al filtro
      cantidadComentarios: 0,
      auditados: [],
      atencionAuditoriaService,
      username: "johny_01",
      email: "john@admin.com",
      company: "SnowMash Technologies Pvt Ltd",

      establecimiento: null,
      establecimientoOpts: [],
      isLoading: false,
      cantidadComentariosByAuditor: 0,
      auditadosByAuditor: [],
    };
  },

  created() {
    this.loadInitData();
  },

  methods: {
    doSearch() {
      this.search = this.searchInput.toLowerCase();
      this.dateFilter = this.dateInput; // aplicar fecha seleccionada
      this.currentPage = 1;
    },

    clearSearch() {
      this.search = "";
      this.searchInput = "";
      this.dateFilter = null;
      this.dateInput = null;
      this.currentPage = 1;
    },
    irAtencion(token) {
      this.$bvModal.hide("modal-auditadas");
      this.$bvModal.hide("modal-auditadas-user");

      this.$router.push({
        path: "/atenciones-medicas",
        query: {
          view_atencion: token,
        },
      });
    },
    openModalAuditadas() {
      this.$bvModal.show("modal-auditadas");
    },
    openModalAuditadasByUser() {
      this.$bvModal.show("modal-auditadas-user");
    },
    async loadInitData() {
      this.isLoading = true;
      try {
        const opts = await establecimientosService.getForSelect();
        this.establecimientoOpts = Array.isArray(opts) ? opts : [];
      } catch (e) {
        this.establecimientoOpts = [];
      }
      try {
        const est = getEstablecimientoLS && getEstablecimientoLS();
        this.establecimiento = est && est.id ? est.id : null;
      } catch (e) {
        this.establecimiento = null;
      }

      try {
        const detalleUsuario = JSON.parse(
          localStorage.getItem("detalleusuario")
        );
        const doctorSet = detalleUsuario?.persona?.doctorSet;
        const idDoctor =
          Array.isArray(doctorSet) && doctorSet.length > 0
            ? doctorSet[0].id
            : null;
        if (idDoctor) {
          const result =
            await atencionAuditoriaService.consultarCantidadComentariosAuditoria(
              idDoctor
            );
          this.cantidadComentarios = result.cantidad;
          this.auditados = result.atencionesAuditadas;
          console.log("AUDITADOS", this.auditados);
        } else {
          this.cantidadComentarios = 0;
          this.auditados = 0;
        }
      } catch (e) {
        console.log("error", e);
        this.cantidadComentarios = 0;
      }

      try {
        const usuario = JSON.parse(localStorage.getItem("usuario"));
        if (usuario) {
          let idUser = usuario?.id;
          const result =
            await atencionAuditoriaService.consultarCantidadComentariosByAuditor(
              idUser
            );
          this.cantidadComentariosByAuditor = result.cantidad;
          this.auditadosByAuditor = result.atencionesAuditadas;
          console.log("AUDITADOS BY AUDITOR", this.auditadosByAuditor);
        }
      } catch (e) {
        console.log("error", e);
        this.cantidadComentariosByAuditor = 0;
      }

      this.isLoading = false;
    },

    async confirmChange(newValue) {
      if (this.establecimiento === newValue) return;

      const result = await this.$swal({
        title: "Estas seguro de cambiar de establecimiento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      });

      if (!result.isConfirmed) return;
      this.establecimiento = newValue;

      // cambiar el ls
      const detalleUsuario = JSON.parse(localStorage.getItem("detalleusuario"));

      const dataEstablecimiento = this.establecimientoOpts.find(
        (est) => est.value === newValue
      );

      const establecientoForLs = {
        id: dataEstablecimiento.value,
        Descripcion: dataEstablecimiento.text,
        uniCodigo: dataEstablecimiento.unicode,
      };

      const newDetalleUsuario = {
        ...detalleUsuario,
        establecimiento: establecientoForLs,
      };

      localStorage.setItem("detalleusuario", JSON.stringify(newDetalleUsuario));
      this.$router.go(0);
    },

    logout() {
      localStorage.removeItem("usuario");
      localStorage.removeItem("detalleusuario");
      localStorage.removeItem("permisos");

      localStorage.clear();

      this.$router.push({ name: "login" });
    },

    abrirPerfilUsuario() {
      this.$router.push({ name: "mi-perfil" });
    },
  },

  computed: {
    filteredItems() {
      return this.auditadosByAuditor.filter((item) => {
        const p = item.cita.paciente.persona;

        const texto = this.search;

        const cedula = p.identificacion?.toLowerCase() || "";
        const nombre = p.primerNombre?.toLowerCase() || "";
        const apellido = p.primerApellido?.toLowerCase() || "";
        const fecha = item.cita.fechaCita || "";
        const estado = item.estadoauditoria || "";

        // ⭐ FILTRO TEXTO
        const matchTexto =
          !texto ||
          cedula.includes(texto) ||
          nombre.includes(texto) ||
          apellido.includes(texto);

        // ⭐ FILTRO FECHA
        const matchFecha = !this.dateFilter || fecha === this.dateFilter;

        // ⭐ FILTRO ESTADO (preseleccionado '2')
        const matchEstado = !this.estadoFilter || estado === this.estadoFilter;

        return matchTexto && matchFecha && matchEstado;
      });
    },

    pagedFilteredItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredItems.slice(start, end);
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.auditadosByAuditor.slice(start, end);
    },
    establecimientoName() {
      const stored = localStorage.getItem("establecimientoSeleccionado");
      const parsed = stored ? JSON.parse(stored) : null;
      if (parsed) {
        if (parsed.text) return parsed.text;
        if (parsed.Descripcion) return parsed.Descripcion;
        if (parsed.nombre) return parsed.nombre;
      }

      const host = window.location.hostname;
      const establecimiento = ESTABLECIMIENTOS.find((e) => e.ip === host);
      return establecimiento ? establecimiento.nombre : "";
    },

    environmentLabel() {
      const environment = localStorage.getItem(API_ENV_STORAGE_KEY);
      return environment === "test" ? "PRUEBAS" : "PRODUCCION";
    },

    environmentBadgeClass() {
      return this.environmentLabel === "PRUEBAS" ? "text-warning" : "text-primary";
    },

    usuario() {
      return JSON.parse(localStorage.getItem("usuario"));
    },

    detalleusuario() {
      return JSON.parse(localStorage.getItem("detalleusuario"));
    },

    isJefeMedico() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.JEFE_AUDITOR,
        ROLES.JEFE_DERIVADOR,
      ]);
    },

    showChangeEstablecimiento() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.JEFE_DERIVADOR,
        ROLES.JEFE_AUDITOR,
        ROLES.AUDITOR,
        ROLES.DERIVADOR,
        ROLES.ESTADISTICAS,
      ]);
    },
  },
};
</script>
